import { render, staticRenderFns } from "./location-settings.vue?vue&type=template&id=eb800e3a&scoped=true"
import script from "./location-settings.vue?vue&type=script&lang=ts"
export * from "./location-settings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb800e3a",
  null
  
)

export default component.exports